export const SLICE_NAME = 'vlAccess';
